import { useNavigate } from 'react-router-dom';

/**
 * Action buttons panel for live session
 */
export const LiveSessionActionsPanel = ({ 
  session, 
  isConsultant, 
  endingSession, 
  showSummary,
  onEndSession,
  onCancelSession,
  onCompleteSession,
  onLeaveSession,
  onToggleSummary
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Actions</h3>
      
      {isConsultant ? (
        <div className="space-y-3">
          {session?.status === 'active' && (
            <>
              {/* Consultant View-Only: No action buttons during active session */}
              <div className="p-4 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg">
                <p className="text-sm text-blue-800 dark:text-blue-300">
                  <span className="font-semibold">👀 Viewing Mode</span>
                  <br/>
                  You're observing this session in real-time. Only the user can submit the assessment.
                </p>
              </div>
              
              <button
                onClick={onEndSession}
                disabled={endingSession}
                className="w-full px-4 py-2 bg-gray-600 dark:bg-gray-700 text-white rounded-md hover:bg-gray-700 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
              >
                {endingSession ? 'Ending Session...' : 'End Session'}
              </button>
              
              <button
                onClick={onCancelSession}
                disabled={endingSession}
                className="w-full px-4 py-2 bg-red-600 dark:bg-red-700 text-white rounded-md hover:bg-red-700 dark:hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
              >
                ✕ Cancel Session
              </button>
            </>
          )}
          
          {session?.status === 'completed' && (
            <button
              onClick={onToggleSummary}
              className="w-full px-4 py-2 bg-emerald-600 dark:bg-emerald-500 text-white rounded-md hover:bg-emerald-700 dark:hover:bg-emerald-600 font-medium"
            >
              {showSummary ? 'Hide' : 'View'} Summary
            </button>
          )}
          
          <button
            onClick={() => navigate('/consultant/dashboard')}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 font-medium"
          >
            ← Back to Clients
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {session?.status === 'active' && (
            <button
              onClick={onLeaveSession}
              disabled={endingSession}
              className="w-full px-4 py-2 bg-gray-600 dark:bg-gray-700 text-white rounded-md hover:bg-gray-700 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
            >
              ← Leave Session
            </button>
          )}
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 font-medium"
          >
            ← Back to Dashboard
          </button>
        </div>
      )}
    </div>
  );
};

